import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

/**
 * 交易类型状态映射 Hook
 * 用于将交易类型代码转换为对应的多语言文本
 */
export const useCardListStatus = () => {
  const { t } = useTranslation()

  const getCardListStatus = useCallback((type: string, defaultText?: string) => {
    switch (type) {
      case 'A':
        return t('授权')
      case 'D':
        return t('授权撤销')
      case 'C':
        return t('结算')
      case 'R':
        return t('退款')
      default:
        return defaultText || '-'
    }
  }, [t])

  return { getCardListStatus }
}



export const useAssetListStatus = () => {
  const { t } = useTranslation()
  const getAssetListStatus = useCallback((type: string, defaultText?: string) => {
    switch (type) {
      case 'token_recharge':
        return t('存款代币')
      case 'open_virtual_card_fee':
        return t('电子卡申请费')
      case 'card_auth':
        return t('电子卡授权')
      case 'card_auth_reverse':
        return t('电子卡撤销授权')
      case 'card_clearing':
        return t('电子卡结算')
      case 'card_clearing_refund':
        return t('电子卡退款')
      case 'exchange':
        return t('兑换')
      case 'bank_transfer':
        return t('汇款')
      case 'open_physical_card_fee':
        return t('实体卡申请费')
      case 'claim':
        return t('领取')
      default:
        return defaultText || '-'
    }
  }, [t])

  return { getAssetListStatus }
}

export const useRechargeListStatus = () => {
  const { t } = useTranslation()
  const getRechargeListStatus = useCallback((type: string, defaultText?: string) => {
    switch (type) {
      case 'Submitted':
        return t('已提交')
      case 'PendingScreening':
        return t('待审核')
      case 'PendingAuthorization':
        return t('待授权')
      case 'PendingSignature':
        return t('待签名')
      case 'Broadcasting':
        return t('广播中')
      case 'Confirming':
        return t('确认中')
      case 'Completed':
        return t('已完成')
      case 'Failed':
        return t('失败')
      case 'Rejected':
        return t('已拒绝')
      case 'Pending':
        return t('待处理')
      default:
        return defaultText || '-'
    }
  }, [t])

  return { getRechargeListStatus }
}

/**
 * 汇款状态映射 Hook
 * 用于将汇款状态代码转换为对应的多语言文本
 */
export const useRemittanceListStatus = () => {
  const { t } = useTranslation()
  const getRemittanceListStatus = useCallback((status: string, defaultText?: string) => {
    switch (status) {
      case 'pending':
        return t('处理中')
      case 'success':
        return t('成功')
      case 'failed':
        return t('失败')
      default:
        return defaultText || '-'
    }
  }, [t])

  return { getRemittanceListStatus }
}
